import React from 'react'

function SvgPrint(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M19 8a2.84 2.84 0 012.11.89A2.84 2.84 0 0122 11v6h-4v4H6v-4H2v-6a2.84 2.84 0 01.89-2.11A2.84 2.84 0 015 8zm-1-5v4H6V3zm-2 16v-5H8v5zm2.3-7.26a.94.94 0 00.7.26 1 1 0 00.73-.28A.93.93 0 0020 11a1.06 1.06 0 00-1-1 .93.93 0 00-.7.31 1 1 0 00-.3.69.94.94 0 00.28.72z" />
    </svg>
  )
}

export default SvgPrint
